import React from "react";
import type { AppointmentStatus } from "../../services/appointment.service";

interface Props {
  status: AppointmentStatus;
  size?: "sm" | "md";
}

const CONFIG: Record<AppointmentStatus, { label: string; pill: string; dot: string }> = {
  requested:   { label: "Requested",    pill: "bg-yellow-50 text-yellow-700 border border-yellow-200", dot: "bg-yellow-500" },
  approved:    { label: "Approved",     pill: "bg-orange-50 text-orange-700 border border-orange-200", dot: "bg-orange-500" },
  scheduled:   { label: "Scheduled",    pill: "bg-blue-50 text-blue-700 border border-blue-200",       dot: "bg-blue-500" },
  confirmed:   { label: "Confirmed",    pill: "bg-cyan-50 text-cyan-700 border border-cyan-200",       dot: "bg-cyan-500" },
  in_progress: { label: "In Progress",  pill: "bg-amber-50 text-amber-700 border border-amber-200",    dot: "bg-amber-500" },
  completed:   { label: "Completed",    pill: "bg-green-50 text-green-700 border border-green-200",    dot: "bg-green-500" },
  cancelled:   { label: "Cancelled",    pill: "bg-slate-100 text-slate-500 border border-slate-200",   dot: "bg-slate-400" },
  no_show:     { label: "No Show",      pill: "bg-red-50 text-red-600 border border-red-200",          dot: "bg-red-500" },
};

export const AppointmentStatusBadge: React.FC<Props> = ({ status, size = "md" }) => {
  const cfg = CONFIG[status] ?? CONFIG["scheduled"];
  const text = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";

  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${cfg.pill} ${text}`}>
      <span className={`h-1.5 w-1.5 rounded-full flex-shrink-0 ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
};